import { useTypedSelector } from "store/reducers/use-typed-selector";
import { FeatureFlagsEnum } from "types/working-model";

const isAlphaEmail = (email: string | undefined) =>
	!!(email && /(@brandlive\.com|@yourbrandlive\.com)$/.test(email));

export const useProjectDetailsEnabled = () => {
	const flags = useTypedSelector(state => state.FeatureFlagsReducer.featureFlags);
	const user = useTypedSelector(state => state.AuthReducer.user);
	const betaOptIn = user?.beta_opt_ins || [];

	// if full flag, always on for everyone
	if (flags[FeatureFlagsEnum.project_details_full]) {
		return true;
	}

	// if alpha flag, only on for brandlive email users who opted in
	if (flags[FeatureFlagsEnum.project_details]) {
		return (
			isAlphaEmail(user?.email) &&
			betaOptIn.includes(FeatureFlagsEnum.project_details)
		);
	}

	return false;
};